<template>
    <div>
        <!-- VIEW -->
        <v-container>
            <v-row class="ma-0">
                <v-col>
                <p class="headline text-center">Laporan Vendor</p>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="12">
                    <v-data-table
                            class="elevation-1"
                            :headers="table1.headers"
                            :items="table1.items"
                            :items-per-page="5"
                            :single-select="true"
                            item-key="id"
                            no-data-text="Belum ada data !"
                            fixed-header>
                            
                            <template v-slot:item.status="{item}">
                                {{ statusCap(item.status) }}
                            </template>
                            
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>
                                        <v-btn color="primary darken-1" @click="exportExcelLaponanVendor()">Export Excel</v-btn>
                                    </v-toolbar-title> 
                                </v-toolbar>
                            </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row class="ma-0">
                <v-col cols="6">
                    <v-data-table
                            class="elevation-1"
                            :headers="table2.headers"
                            :items="table2.items"
                            :items-per-page="5"
                            :single-select="true"
                            item-key="id"
                            no-data-text="Belum ada data !"
                            fixed-header>
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Perusahaan Pengikut Tender</v-toolbar-title>
                                </v-toolbar>
                            </template>
                    </v-data-table>
                </v-col>
                <v-col cols="6">
                    <v-simple-table>
                        <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Status Perusahaan</v-toolbar-title>
                                </v-toolbar>
                            </template>
                        <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">
                                    Status
                                </th>
                                <th class="text-left">
                                    Jumlah
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Aktif</td>
                                <td>{{ table3.items.aktif }}</td>
                            </tr>
                            <tr>
                                <td>Non Aktif</td>
                                <td>{{ table3.items.nonAktif }}</td>
                            </tr>
                            <tr>
                                <td>Persiapan Verifikasi</td>
                                <td>{{ table3.items.persiapanVerifikasi }}</td>
                            </tr>
                            <tr>
                                <td>Menunggu Verifikasi</td>
                                <td>{{ table3.items.menungguHasilVerifikasi }}</td>
                            </tr>
                            <tr>
                                <td>Masa Berlaku Habis</td>
                                <td>{{ table3.items.masaBerlakuHabis }}</td>
                            </tr>
                            <tr>
                                <td>Suspend</td>
                                <td>{{ table3.items.suspend }}</td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>

import { statusVendor } from './../../lib/viewLib'
const axios = require("axios").default;
const apiUrl = process.env.VUE_APP_ROOT_API;

export default{
    data() {
        return {
            table1: {
                headers: [
                    { text: "ID", value:"id"},
                    { text: "Nama Perusahaan", value:"nama"},
                    { text: "Bentuk Perusahaan", value:"bentuk"},
                    { text: "Alamat Perusahaan", value:"alamat"},
                    { text: "Status Vendor", value:"status"},
                ],
                items: []
            },
            table2: {
                headers: [
                    { text: "Nama Perusahaan", value:"nama"},
                    { text: "Jumlah Tender", value:"jumlahTender"},
                ],
                items: []
            },
            table3: {
                items: []
            }
        }
    },
    created() {
        this.getData();
    },
    methods: {
        statusCap: status => statusVendor.find(el => el.status === status).caption,
        getData() {
            axios.get(`${apiUrl}/laporan/laporan-vendor`)
            .then((response) => {
                this.table1.items = response.data.data.dataVendor;
                this.table2.items = response.data.data.dataTotaTenderVendor;
                this.table3.items = response.data.data.dataStatusVendor[0];
                console.log('this.table3.items',this.table3.items);
            })
            .catch((error) => {
                console.error(error);
            });
        },
        exportExcelLaponanVendor() {
            axios.get(`${apiUrl}/laporan/xls/laporan-vendor`)
            .then((response) => {
                if(response.status === 200) {
                    this.getLinkDownload(response.data.file);
                }
            })
            .catch((error) => {
                console.error(error);
            });
        },
        getLinkDownload: function(dok) {
            axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
            .then(response => {
                const blob = new Blob([response.data], { type: response.headers['content-type'] })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = dok
                link.click()
                URL.revokeObjectURL(link.href)
            }).catch(console.error)
        },
    }
}
</script>

<style scoped>
    .container{
        max-width: 100vw;
        padding:0px;
    }

</style>